<template>
  <div class="radio-group">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {}
  },
  watch: {
    value() {
      this.updateChildren()
    }
  },
  mounted() {
    this.updateChildren()
  },
  methods: {
    updateCheck(value) {
      if (this.value !== value) {
        this.$emit('input', value)
        this.$emit('change', value)
      } else {
        this.$emit('input', '')
        this.$emit('change', '')
      }
    },
    updateChildren() {
      this.$children.forEach((item) => {
        item.checked = this.value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-group {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  .radio-item-2 {
    margin-right: 11px;
  }
  .radio-item-2:nth-child(2n) {
    margin-right: 0;
  }
  .radio-item-two {
    margin-right: 42px;
  }
  .radio-item-two:nth-child(2n) {
    margin-right: 0;
  }
}
</style>
